import IInterventionDetails from 'models/InterventionDetails';

import { ReduxStore } from 'store/types';

function getDetailsValues(state: ReduxStore): IInterventionDetails | null {
  return state.intervention.getDetails.values;
}

export default getDetailsValues;
